import { showDialogWithData } from "../../../../../redux/guest-slices/other.slice"
import TablePagination from "../../../../../components/common/TablePagination"
import Messages from "../../../../../components/dashboard/Messages/chat"
import { useChatInitiate } from "../../../../../hooks/useChatInitiate"
import TableSkell from "../../../../../components/common/TableSkell"
import { chipVariants, pendingAppoHeaders } from "../data"
import { FOLLOW_UP } from "../../../../../utils/keywords"
import { useDispatch, useSelector } from "react-redux"
import Icons from "../../../../../assets/js/Icons"
import moment from "moment"
import { useNavigate } from "react-router-dom"

import {
  Chip, Collapse, Grid2 as Grid, IconButton, ListItemText, Paper, Table,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Typography
} from "@mui/material"


function Appointments({ data, handleRetrieveAll }) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { isActive, isAppointment, initiateAppointmentChat } = useChatInitiate()
  const { loadings } = useSelector((state) => state.otherSlice)
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const formatTime = (utc) => moment(utc).tz(userTimeZone).format("h:mm A")
  const formatDate = (utc) => moment(utc).tz(userTimeZone).format("MM-DD-YYYY")

  // --------------- Handle add followup ---------------
  const openFollowUpModal = (item) => {
    dispatch(
      showDialogWithData({
        type: FOLLOW_UP,
        data: {
          memberId: item.memberId,
          specialistId: data?.specialistInfo?._id,
        },
      })
    )
  }

  // --------------- Handle chat initiate ---------------
  const handleChatInitiate = async (appointment) => {
    appointment.specialistInfo = data?.specialistInfo
    const chat = await initiateAppointmentChat(appointment)
    if (chat) {
      navigate("/member/profile/appointment-messages", { state: "test" })
    }
  }

  return (
    <Grid container spacing={3} mt={3}>
      <Grid size={{ xs: 12, lg: "grow" }}>
        <Paper variant="contentListing">
          <TableContainer variant="tableViewA">
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {pendingAppoHeaders?.map((element, i) => (
                    <TableCell key={i} align="left">{element}</TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {loadings?.retrieveAll ? (
                  <TableSkell colLength={pendingAppoHeaders?.length} />
                ) : (
                  data?.appointments?.map((element, i) => (
                    <TableRow
                      key={i}
                      sx={{ td: { borderBottomWidth: i === data?.appointments?.length - 1 ? "0" : "1px" } }}
                    >
                      <TableCell>
                        <ListItemText
                          sx={{ m: 0 }}
                          primary={formatDate(element?.startTime)}
                          secondary={formatTime(element?.startTime) + "-" + formatTime(element?.endTime)}
                          slotProps={{
                            primary: { style: { fontSize: 15, lineHeight: "1.2" } },
                            secondary: { style: { fontSize: 13, lineHeight: "1.2" } },
                          }}
                        />
                      </TableCell>
                      <TableCell>{formatDate(element?.createdAt)}</TableCell>
                      <TableCell>
                        <Chip
                          key={i}
                          size="small"
                          variant="statusChip"
                          color={chipVariants[element?.appointmentStatus]}
                          label={element?.appointmentStatus === "no-show" ? "No Show" : element?.appointmentStatus}
                        />
                      </TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          title="Accept"
                          color="primary"
                          sx={{ p: 0.25, fontSize: 20, mr: 0.5 }}
                          onClick={() => openFollowUpModal(element)}
                        ><Icons.EditSolid />
                        </IconButton>
                        <IconButton
                          size="small"
                          title="Message Specialist"
                          color="primary"
                          sx={{ p: 0.25, fontSize: 20 }}
                          onClick={() => {
                            handleChatInitiate(element)
                          }}
                        ><Icons.ChatStrokeRounded />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}

                {!data?.appointments?.length && !loadings?.retrieveAll && (
                  <TableRow sx={{ td: { borderBottom: "none" } }}>
                    <TableCell colSpan={pendingAppoHeaders?.length}>
                      <Typography variant="noRecords">No results found!</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            mt={0.001}
            color="primary"
            cb={handleRetrieveAll}
            pagination={data?.pagination}
            loading={loadings?.retrieveAll}
            length={data?.appointments?.length}
          />
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, lg: "auto" }}>
        <Collapse
          timeout={300}
          unmountOnExit
          orientation="horizontal"
          in={isActive && isAppointment}
        >
          <Messages />
        </Collapse>
      </Grid>
    </Grid>
  )
}

export default Appointments